import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import { getLotSizingLinesBySupplierInfiniteQueryKey } from '@/features/lot-sizing/hooks/use-lot-sizing-lines-by-supplier';
import { GET_LOT_SIZING_KEY } from '@/keys';

export type UpdateLotSizingSupplierLinesCheckedParams = {
  lotSizingId: string;
  supplierId: string;
  checked: boolean;
};

const updateLotSizingSupplierLinesChecked = async ({
  lotSizingId,
  supplierId,
  checked,
}: UpdateLotSizingSupplierLinesCheckedParams): Promise<void> => {
  await api.patch(`/lot-sizings/${lotSizingId}/suppliers/${supplierId}/lines`, {
    checked,
  });
};

export function useUpdateLotSizingSupplierLinesChecked(): UseMutationResult<
  void,
  Error,
  UpdateLotSizingSupplierLinesCheckedParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateLotSizingSupplierLinesChecked,
    onSuccess: async (_, { lotSizingId, supplierId }) => {
      const queryKey = getLotSizingLinesBySupplierInfiniteQueryKey(
        lotSizingId,
        supplierId,
      );

      await queryClient.refetchQueries({
        queryKey: [...GET_LOT_SIZING_KEY, lotSizingId],
      });
      await queryClient.invalidateQueries({ queryKey });
    },
  });
}
